module.exports = __webpack_public_path__ + "static/img/introduce_2.d80b59e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce_2.png
// module id = fGvE
// module chunks = 1